// The axios wrapper
import axios from "axios";
// const domain = 'http://64.225.86.23:8000';
const domain = 'https://gni-dctool.uc.r.appspot.com';

class Service {
  constructor() {
    let service = null;

    service = axios.create({
      headers: {
        // Authorization: this.getAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
    this.state = {
      statusCode: null
    };
  }

  async getAccessToken() {
    try {
      const value = await localStorage.getItem("id_token");
      if (value !== null) {
        return value;
      } else {
        return "";
      }
    } catch (error) {
      return "";
    }
  }

  handleSuccess(response) {
    return response;
  }


  // handleError = error => {
  //   switch (error.code) {
  //     case 401:
  //       console.log(error);
  //       console.log("401: Something went wrong");
  //       break;
  //     case 409:
  //       console.log(error);
  //       console.log("409: Something went wrong");
  //       break;
  //     case 404:
  //       console.log("404: Something went wrong!");
  //       break;
  //     case 500:
  //       console.log("500: Something went wrong!");
  //       break;
  //     case 502:
  //       console.log("502: Something went wrong!");
  //       break;
  //     default:
  //       console.log(error);
  //       break;
  //   }
  // };


  get(path, options) {
    return this.service
      .get(domain + path, {
        ...options
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject((error.response) ? error.response : error));
  }

  patch(path, options) {
    return this.service
      .request({
        method: "PATCH",
        url: domain + path,
        ...options
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject((error.response) ? error.response : error));
  }

  update(path, options) {
    return this.service
      .request({
        method: "UPDATE",
        url: domain + path,
        ...options
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject((error.response) ? error.response : error));
  }

  post(path, options) {
    return this.service
      .request({
        method: "POST",
        url: domain + path,
        ...options
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject((error.response) ? error.response : error));
  }

  put(path, options) {
    return this.service
      .request({
        method: "PUT",
        url: domain + path,
        ...options
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject((error.response) ? error.response : error));
  }

  delete(path, options) {
    return this.service
      .request({
        method: "DELETE",
        url: domain + path,
        ...options
      })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject((error.response) ? error.response : error));
  }
}

export default new Service();
